import Joi from 'joi';
import placemenetSearchSchema from 'components/Placement/Search/schema';

const schema = {
  ...placemenetSearchSchema,
  orientation: Joi.string(),
  presentation: Joi.boolean(),
};

export default schema;
